/**
 * "Still need help?" call-to-action section
 */

import { Link } from 'react-router-dom';
import { HelpCircle, MessageCircle, Users } from 'lucide-react';

export function HelpCTA(): JSX.Element {
  return (
    <section className="mt-12 bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-xl p-8 text-center">
      <div className="max-w-xl mx-auto">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-amber-100 dark:bg-amber-800/30 rounded-full">
            <HelpCircle className="w-8 h-8 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Still need help?
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Can't find the answer you're looking for? Our support team is ready to help you.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="btn btn-primary inline-flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} />
            Contact Support
          </Link>
          <a
            href="https://community.foxiesystems.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline inline-flex items-center justify-center gap-2"
          >
            <Users size={18} />
            Join Community Forum
          </a>
        </div>
      </div>
    </section>
  );
}

export default HelpCTA;
